import { computed, Ref } from 'vue'
import { Book, Question } from '@/models'
import { swalConfirm } from '@/utils'

export function useQuestionSetting(book: Ref<Book>) {
  /** 現在の設問の中で最大のID */
  const maxId = computed(() => Math.max(...book.value.questions.map(row => row.id)))

  /**
   * 設問の項目を追加する
   */
  function addQuestion() {
    book.value.questions.push(new Question({ id: maxId.value + 1 }))
  }

  /**
   * 設問の項目を削除する
   */
  function deleteQuestion(i: number) {
    swalConfirm.fire({ text: '設問を削除してよろしいですか？' }).then(result => {
      if (result.isConfirmed) {
        book.value.questions.splice(i, 1)
      }
    })
  }

  return { addQuestion, deleteQuestion }
}
